import React from 'react';
import { DataRowState, SelectAllRowsAction } from '../types';
import BaseCheckbox from './BaseCheckbox';

type DataColCheckboxType<T> = {
  keyField: string;
  selectableRowDisabled: DataRowState<T>;
  rowData: T[];
  selectedRows: T[];
  mergeSelections: boolean;
  allSelected: boolean;
  onSelectAllRows: (action: SelectAllRowsAction<T>) => void;
};

function DataColCheckbox<T>({
  keyField,
  selectableRowDisabled,
  rowData,
  mergeSelections,
  selectedRows,
  allSelected,
  onSelectAllRows,
}: DataColCheckboxType<T>): JSX.Element {
  const indeterminate = selectedRows.length > 0 && !allSelected;
  const rows = selectableRowDisabled
    ? rowData.filter((row: T) => !selectableRowDisabled(row))
    : rowData;
  const isDisabled = rows.length === 0;
  const rowCount = Math.min(rowData.length, rows.length);

  const handleSelectAll = () => {
    onSelectAllRows({
      type: 'SELECT_ALL_ROWS',
      rows,
      rowCount,
      mergeSelections,
      keyField,
    });
  };

  return (
    <div
      className='relative flex items-center justify-center select-none whitespace-nowrap box-border leading-normal'
      style={{ flex: '0 0 48px' }}
    >
      <BaseCheckbox
        name='select_all_rows'
        onClick={handleSelectAll}
        checked={allSelected}
        disabled={isDisabled}
        indeterminate={indeterminate}
      />
    </div>
  );
}

export default DataColCheckbox;
